export default "__VITE_ASSET__0v3CJJE5__"